module.exports = __webpack_public_path__ + "img/blue3.1f2a20f5.jpg";